import { createAction, props } from '@ngrx/store';

export const initConnectTokenStateSuccess = createAction(
  '[Connect] Initialize connect token state success',
  props<{ token: string }>(),
);

export const initConnectTokenStateFailure = createAction(
  '[Connect] Initialize connect token state failure',
  props<{ error: string }>(),
);

export const acquireConnectToken = createAction(
  '[Connect] Acquire connect token',
  props<{ accessToken: string }>(),
);

export const resetConnectToken = createAction('[Connect] Reset connect token');
